export default function ({ store }) {
	// If the user is not authenticated
	store.commit('HIDE_FULLMENU');
}
